var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.step === _vm.activeStep)?_c('div',[_vm._t("default"),(_vm.showButtons)?_c('StepperButtons',{attrs:{"active-step":_vm.activeStep,"steps":_vm.steps},on:{"set-step":_vm.setStep}}):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }